import { NavLink } from "react-router-dom";
import { ROUTES } from "../../routes";
import styles from "./Sidebar.module.css";

const SECTIONS = [
  {
    label: "Overview",
    items: [{ to: ROUTES.HOME, label: "Dashboard", icon: "🏠" }],
  },
  {
    label: "Security",
    items: [
      { to: ROUTES.SECURITY_MONITORING, label: "Security Monitoring", icon: "🛡️" },
      { to: ROUTES.AUDIT_LOG, label: "Audit Log", icon: "📜" },
      { to: ROUTES.COMPLIANCE, label: "Compliance & GDPR", icon: "⚖️" },
      { to: ROUTES.REVIEW_ACCESS_REQUESTS, label: "Access Requests", icon: "🔑" },
    ],
  },
  {
    label: "Analytics",
    items: [
      { to: ROUTES.THEME_ANALYTICS, label: "Theme Analytics", icon: "🎨" },
      { to: ROUTES.SUBSCRIPTION_ANALYTICS, label: "Subscription Analytics", icon: "💳" },
      { to: ROUTES.FEATURE_ADOPTION, label: "Feature Adoption", icon: "🧭" },
      { to: ROUTES.DORMANT_ACCOUNTS, label: "Dormant Accounts", icon: "🚪" },
      { to: ROUTES.COST_MONITORING, label: "Cost Monitoring", icon: "💰" },
      { to: ROUTES.SENTIMENT_ANALYSIS, label: "User Sentiment", icon: "💬" },
      { to: ROUTES.MOBILE_ANALYTICS, label: "Mobile Analytics", icon: "📱" },
      { to: ROUTES.BLOOM_ANALYTICS, label: "Bloom Calendar", icon: "🌸" },
    ],
  },
  {
    label: "Operations",
    items: [
      { to: ROUTES.SUPPORT_TICKETS, label: "Support Tickets", icon: "🎧" },
      { to: ROUTES.PERFORMANCE_MONITORING, label: "Performance", icon: "⚡" },
      { to: ROUTES.APP_INSIGHTS, label: "App Insights", icon: "🔍" },
    ],
  },
  {
    label: "Management",
    items: [
      { to: ROUTES.USER_MANAGEMENT, label: "User Management", icon: "👤" },
      { to: ROUTES.FEATURE_FLAGS, label: "Feature Flags", icon: "🚩" },
      { to: ROUTES.SYSTEM_MANAGEMENT, label: "System", icon: "🛠️" },
    ],
  },
  {
    label: "Reporting",
    items: [{ to: ROUTES.CUSTOM_REPORTING, label: "Custom Reports", icon: "📈" }],
  },
];

export function Sidebar({ open, onNavigate }) {
  return (
    <nav className={[styles.sidebar, open ? styles.open : ""].join(" ")} aria-label="Admin navigation">
      {SECTIONS.map((section) => (
        <div className={styles.section} key={section.label}>
          <div className={styles.sectionLabel}>{section.label}</div>
          <ul className={styles.list}>
            {section.items.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === ROUTES.HOME}
                  onClick={onNavigate}
                  className={({ isActive }) => [styles.link, isActive ? styles.active : ""].join(" ")}
                >
                  <span aria-hidden="true" className={styles.icon}>{item.icon}</span>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}
